module.exports = __webpack_public_path__ + "img/pencil.da48e832.svg";